if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.scrollPosition = 0;
      }

      hide() {
        super.hide();
        // Remove scroll lock
        document.documentElement.classList.remove('overflow-hidden');
        document.documentElement.style.position = '';
        document.documentElement.style.top = '';
        document.documentElement.style.height = '';
        // Restore scroll position
        window.scrollTo(0, this.scrollPosition);
      }

      show(opener) {
        // Save current scroll position
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        // Apply scroll lock with position fixed
        document.documentElement.classList.add('overflow-hidden');
        document.documentElement.style.position = 'fixed';
        document.documentElement.style.top = `-${this.scrollPosition}px`;
        document.documentElement.style.height = '100%';
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        
        // Scroll to active media without affecting page scroll
        const slider = this.querySelector('[id^="Slider-"]');
        if (slider && activeMedia) {
          slider.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: 'instant'
          });
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
